import { render, staticRenderFns } from "./PmslCommandDemo.vue?vue&type=template&id=8277bfba"
import script from "./PmslCommandDemo.vue?vue&type=script&lang=js"
export * from "./PmslCommandDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports